import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 정적 사이트에서는 페이지 이동(process.html, apply.html 등)이 새 문서 로드라
 * 항상 스크롤이 맨 위에서 시작됐다. React Router는 SPA라 이 동작을 직접
 * 재현해줘야 한다.
 * - 해시가 없으면(/process 등) 맨 위로 이동.
 * - 해시가 있으면(/process#inquiry 등) 해당 id 요소로 스크롤한다.
 *   일반 브라우저 내비게이션과 달리 SPA 라우팅(pushState)은 해시가 있어도
 *   자동으로 그 위치로 스크롤해주지 않기 때문에 직접 처리해야 한다.
 *   다른 페이지로 이동하는 경우 그 페이지의 콘텐츠가 아직 커밋되기 전일 수 있어
 *   짧게 재시도한다.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const id = hash.replace('#', '');
    let attempts = 0;
    let timer;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      attempts += 1;
      if (attempts < 20) {
        timer = setTimeout(tryScroll, 50);
      }
    };

    tryScroll();

    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
